import { api } from "./api";

export const customerVerifyListApi = (params) => {
  return api.get(`/manufacturer/customer-verification/list`, { params });
};

export const customerVerifyViewApi = (params) => {
  return api.get(`/manufacturer/customer-verification/view`, {
    params: params,
  });
};

export const customerVerifyReportApi = (params) => {
  return api.post(
    `/manufacturer/customer-verification/report-issue`,
    JSON.stringify(params)
  );
};
